// errorDialogUtil.js
export const showErrorDialog = (setErrorDialogOpen, setErrorMessage, message) => {
    setErrorMessage(message);
    setErrorDialogOpen(true);
  };
  
  export const closeErrorDialog = (setErrorDialogOpen) => {
    setErrorDialogOpen(false);
  };
  